import { useState, useEffect } from 'react';

/**
 * Hook that tracks browser tab visibility using the Page Visibility API.
 * Returns `true` when the tab is visible, `false` when hidden.
 *
 * Use this to gate polling intervals — clear timers when hidden,
 * restart when visible — to avoid wasting network and server resources.
 */
export function usePageVisibility(): boolean {
  const [isVisible, setIsVisible] = useState(!document.hidden);

  useEffect(() => {
    const handler = () => setIsVisible(!document.hidden);
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  }, []);

  return isVisible;
}
